const escapeCSVField = (field) => {
  if (field === null || field === undefined) {
    return '';
  }
  const stringValue = String(field);
  if (stringValue.includes(',') || stringValue.includes('\n') || stringValue.includes('"')) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};


const secondsToHours = (seconds) => {
  if (!seconds || Number.isNaN(seconds)) {
    return 0;
  }
  return (seconds / 3600).toFixed(2);
};

export const exportSprintTasksAsCSV = (sprint) => {
  if (!sprint || !sprint.tasks || sprint.tasks.length === 0) {
    console.warn('No tasks found in sprint');
    return;
  }

  const { tasks, title = 'Sprint Export' } = sprint;

  const headers = [
    'ID',
    'Module',
    'Title',
    'Status',
    'Estimated Time (hours)',
    'Spent Time (hours)',
    'Assignee',
    'Created By',
    'Created Date',
  ];


  const rows = tasks
    .map((task) => [
      escapeCSVField(task.id),
      escapeCSVField(task.module ? task.module.name : ''),
      escapeCSVField(task.title),
      escapeCSVField(task.status),
      escapeCSVField(secondsToHours(task.estimated_time)),
      escapeCSVField(secondsToHours(task.spent_time)),
      escapeCSVField(task.assigneeUser ? task.assigneeUser.name : task.assignee || ''),
      escapeCSVField(task.author ? task.author.name : ''),
      escapeCSVField(task.created_at),
    ]);

  // Combine headers and rows
  const csvContent = [headers.join(','), ...rows.map((row) => row.join(','))].join('\n');

  // Create blob and trigger download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  // Generate filename with sprint title and timestamp
  const timestamp = new Date().toISOString().slice(0, 10);
  const filename = `tasks-${title.replace(/\s+/g, '-')}-${timestamp}.csv`;

  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
